<script>
    //  中间件 用于组件通信
    import Vue from 'vue'
    export default new Vue()
</script>



// WEBPACK FOOTER //
// src/components/bus/bus.vue